var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-swipe',{staticClass:"my-swipe",attrs:{"autoplay":3000}},_vm._l((_vm.images),function(item,index){return _c('van-swipe-item',{key:index},[_c('div',{staticClass:"my-swipe-image"},[_c('van-image',{attrs:{"src":item.url}})],1)])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }